import styled from 'styled-components';
import hexToRgba from 'hex-to-rgba';
import { COLOR } from '../../theme/constants';
import { Button, FlexContainer } from '@emarketer/componentlibrary';

export const NavContainer = styled.div<{ open: boolean }>`
  width: 100%;
  box-sizing: border-box;
  padding: 0 24px;
  position: relative;

  @media (min-width: 1200px) {
    background: ${COLOR.WHITE};
    padding: 30px 10px 10px;
  }

  ${(p) => (p.open ? `z-index: 2` : '')}

  @media (max-width: 1200px) {
    margin-top: 24px;
  }
`;

export const NavTriggerButton = styled(Button)`
  width: 100%;
  font-weight: 700;
  margin: 0;

  &:hover {
    background: none;
    color: initial;
  }
`;

export const NavTrigger = styled.div`
  width: 100%;
  border-radius: 40px;
  min-width: 300px;
  background: ${COLOR.WHITE};
  border: 1px solid ${COLOR.LIGHTGREY};
  height: 46px;
  position: relative;
  z-index: 2;
  margin: 0 auto;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 1024px) {
    max-width: 1170px;
    // -webkit-box-shadow: 3 3px 10px 0 ${hexToRgba(COLOR.BLACK, 0.15)};
    // -moz-box-shadow: 3 3px 10px 0 ${hexToRgba(COLOR.BLACK, 0.15)};
    // box-shadow: 0 3px 10px 0 ${hexToRgba(COLOR.BLACK, 0.15)};
  }

  @media (min-width: 1340px) {
    max-width: 1300px;
  }

  @media (max-width: 1200px) {
    margin-top: 24px;
    position: initial;
  }
`;

export const NavTriggerLeft = styled(FlexContainer)`
  height: 46px;
  font-size: 16px;
  padding-left: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const NavTriggerRight = styled(FlexContainer)`
  width: 50px;
`;

export const NavTriggerContainer = styled(FlexContainer)``;

export const NavText = styled.span`
  display: inline-block;
  color: ${COLOR.DARKGREY}};
`;

export const NavPickerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 600px;
  background: ${COLOR.WHITE};
  z-index: 60;

  @media (max-width: 1200px) {
    z-index: 101;
  }
`;

export const BannerWrapper = styled.div`
  padding: 8px;
  background: #cce5ff;
  border-radius: 3px;
  position: relative;
  display: none;

  @media (max-width: 1200px) {
    display: block;
  }
`;

export const TextHeader = styled.span`
  font-size: 12px;
  font-weight: bold;
  display: block;
`;

export const TextDetail = styled.span`
  font-size: 12px;
  display: block;
`;
